import Vue from 'vue';

// 检测是否授权
export function httpCheckAuthBind(data) {
  return  Vue.$axios({
    url: '/api/third/auth/checkOauthBind',
    method: 'post',
    data
  })
}

// 已授权，登录获取code
export function httpGetAuthCode(data) {
  return Vue.$axios({
    url: '/api/third/auth/getOauthCode',
    method: 'post',
    data
  })
}

// 检测是否绑定(量化)
export function httpCheckBindQuant(data) {
  return Vue.$axios({
    url: 'https://app2.alephrobot.com/api/third/third_auth/checkOauthBind',
    method: 'post',
    third: true,
    data
  })
}

// 检测是否绑定(交易所)
export function httpCheckBindEx(data) {
  return Vue.$axios({
    url: 'https://api.metaearthex.com/third/checkOauthBind',
    method: 'post',
    third: true,
    data
  })
}
